import Slide from './view';

export * from './types';

export default Slide;